var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendarWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.292 11.458)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.786,21.417H8.414A1.415,1.415,0,0,1,7,20v-7.59A1.415,1.415,0,0,1,8.414,11H16a1.416,1.416,0,0,1,1.415,1.414v5.372a1.56,1.56,0,0,1-.456,1.105l-2.069,2.069A1.578,1.578,0,0,1,13.786,21.417ZM8.414,12.042a.372.372,0,0,0-.372.372V20a.372.372,0,0,0,.372.372h5.372a.525.525,0,0,0,.369-.152l2.068-2.068a.523.523,0,0,0,.153-.37V12.414A.372.372,0,0,0,16,12.042Z",
    transform: "translate(-7 -11)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.63 2.465)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.309,18.853a.525.525,0,0,1-.369-.152L8.717,16.478a.521.521,0,0,1,.736-.736l1.829,1.829,3.525-4.027a.521.521,0,1,1,.783.686L11.7,18.677a.517.517,0,0,1-.374.177Z",
    transform: "translate(-8.565 -13.366)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.083)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.4,24.917H2.6a2.607,2.607,0,0,1-2.6-2.6V4.6A2.607,2.607,0,0,1,2.6,2H22.4A2.607,2.607,0,0,1,25,4.6V22.312A2.607,2.607,0,0,1,22.4,24.917ZM2.6,3.042A1.564,1.564,0,0,0,1.042,4.6V22.312A1.564,1.564,0,0,0,2.6,23.875H22.4a1.564,1.564,0,0,0,1.563-1.563V4.6A1.564,1.564,0,0,0,22.4,3.042Z",
    transform: "translate(0 -2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.292)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.479,8.042H.521A.521.521,0,1,1,.521,7H24.479a.521.521,0,1,1,0,1.042Z",
    transform: "translate(0 -7)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.208)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.521,5.208A.521.521,0,0,1,5,4.688V.521a.521.521,0,0,1,1.042,0V4.688A.521.521,0,0,1,5.521,5.208Z",
    transform: "translate(-5)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.521,5.208A.521.521,0,0,1,18,4.688V.521a.521.521,0,0,1,1.042,0V4.688A.521.521,0,0,1,18.521,5.208Z",
    transform: "translate(-18)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarWhite);
export default __webpack_public_path__ + "static/media/iconCalendarWhite.bc221f9ae083eb51cf50f74853ce07cf.svg";
export { ForwardRef as ReactComponent };